import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environment';
import { HttpClient } from '@angular/common/http';
import { TypeBatiment } from '../model/typeBatiment.model';
import { ConfigService } from './config.service';

@Injectable({
    providedIn: 'root',
})
export class TypeBatimentService {

    constructor(
        protected http: HttpClient,
        private config: ConfigService
    ) {}

    getTypeBatiments(): Observable<TypeBatiment[]> {
        return this
            .http
            .get<TypeBatiment[]>(this.config.apiEndpoint + environment.type_batiment_get_collection);
    }
}
